import axios from '../lib/AxApi';

export default
{
    async getStreamByMatchId(matchId)
    {
        let val;
        try
        {
            const response = await axios.get('/WebHandling/getStreamByMatchId', {
                params:
                {
                    matchId,
                },
            });

            val = response.data;
            return val;
        }
        catch (e)
        {
            val = {
                error: true,
                notice: e.toString(),
            };
            return val;
        }
    },
};
